import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';
import LoginBackground from './components/LoginBackground';

const Login = () => {
  const navigate = useNavigate();
  const { signIn, user, loading } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Demo credentials for easy testing
  const demoCredentials = {
    email: '',
    password: ''
  };

  useEffect(() => {
    // Redirect if already authenticated
    if (user && !loading) {
      navigate('/dashboard');
    }
  }, [user, loading, navigate]);

  const handleLogin = async (formData) => {
    setIsLoading(true);
    setError('');

    try {
      const { data, error: signInError } = await signIn(formData?.email, formData?.password);

      if (signInError) {
        // Handle different types of authentication errors
        if (signInError?.message?.includes('Invalid login credentials')) {
          setError('البريد الإلكتروني أو كلمة المرور غير صحيحة');
        } else if (signInError?.message?.includes('Email not confirmed')) {
          setError('يرجى تأكيد بريدك الإلكتروني أولاً');
        } else if (signInError?.message?.includes('Too many requests')) {
          setError('محاولات كثيرة، يرجى المحاولة بعد قليل');
        } else {
          setError(`خطأ في تسجيل الدخول: ${signInError?.message}`);
        }
        return;
      }

      if (data?.user) {
        // Successfully signed in, AuthContext will handle the navigation
        console.log('Sign in successful:', data?.user?.email);
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى');
    } finally {
      setIsLoading(false);
    }
  };

  // Show loading while checking authentication state
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4 relative">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-2 text-muted-foreground">جاري التحقق...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 relative">
      <LoginBackground />
      <div className="w-full max-w-md">
        <div className="bg-card border border-border rounded-2xl shadow-elevation-3 p-8 animate-fade-in">
          <LoginHeader />

          <LoginForm
            onSubmit={handleLogin}
            isLoading={isLoading}
            error={error}
          />

          <LoginFooter />
        </div>

        {/* Demo Credentials Notice */}
        {/* <div className="mt-6 bg-warning/10 border border-warning/20 rounded-lg p-4 animate-slide-up" dir="rtl">
          <div className="flex items-start space-x-3 space-x-reverse">
            <div className="w-6 h-6 bg-warning rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-warning-foreground text-xs font-bold">!</span>
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-warning mb-2">
                بيانات تسجيل الدخول التجريبية
              </p>
              <div className="space-y-1 text-xs text-muted-foreground">
                <p><strong>البريد الإلكتروني:</strong> {demoCredentials?.email}</p>
                <p><strong>كلمة المرور:</strong> {demoCredentials?.password}</p>
              </div>
              <p className="text-xs text-muted-foreground mt-2">
                استخدم هذه البيانات للدخول إلى النظام كمدير
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Login;